import {
  CalendarPickerView,
  MobileDatePicker as MuiDatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";
import {
  DateAndTimePickerProps,
  DatePickerSeparateProps,
  DateRangePickerProps,
  StandardDatePickerProps,
} from "./AppPickers.props";
import React, { ForwardedRef, forwardRef, useState } from "react";
// import { InputLabel } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { KeyboardArrowDown } from "@mui/icons-material";
import RangePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import { getDay } from "date-fns";
import { useDatePickerStyles } from "./AppPicker.styles";
import "./Calendar.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { registerLocale } from "react-datepicker";
import { enUS, it } from "date-fns/locale";
import i18n from "../../../config/i18n";
registerLocale("it", it);
registerLocale("enUS", enUS);
export { AppDatePicker as default };
export const AppDatePicker = forwardRef(function AppDatePicker(
  {
    value,
    label,
    className,
    onChange = () => {},
    minDate,
    maxDate,
    showTodayButton = true,
    readOnly = false,
    required = false,
    inputFormat = "dd/MM/yyyy",
    containerwidth = "",
    containerheight = "",
    showlabel = false,
    InputColor = false,
    fontFamilyForLabel = "",
  }: StandardDatePickerProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const [language, setLanguage] = React.useState("it");
  const effectiveFontFamily =
    fontFamilyForLabel && fontFamilyForLabel != ""
      ? fontFamilyForLabel
      : "MBCorpoAScreen1Cond-Regular-Web";
  React.useEffect(() => {
    const selectedLanguage = i18n.language;
    setLanguage(selectedLanguage);
  }, []);
  const dateValue = value ? new Date(value) : null;
  const commonStyles = {
    height: containerheight,
    fontFamily: "MBCorpoSTitle-Regular-Web-STitle-Regular",
    color: "black",
    "&::placeholder": {
      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
    },
  };

  const renderCustomDateInput = ({
    params,
    containerwidth,
    containerheight,
    InputColor,
    required,
    commonStyles,
  }: {
    params: any;
    containerwidth: string;
    containerheight: string;
    InputColor: boolean;
    required: boolean;
    commonStyles: any;
  }) => (
    <TextField
      {...params}
      style={{
        width: containerwidth,
        height: containerheight,
        backgroundColor: InputColor ? "#D9D9D9" : "#FFFFFF",
        borderRadius: "8px",
      }}
      required={required}
      helperText={""}
      placeholder={"select a date"}
      InputProps={{ readOnly: true, sx: commonStyles }}
      InputLabelProps={{
        sx: {
          "&.MuiInputLabel-root": {
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            marginTop: "-9px",
          },
          "&::placeholder": {
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
          },
          "&.MuiInputLabel-shrink": {
            display: "none",
          },
        },
      }}
    />
  );

  return (
    <>
      <div className={`w-full ${className}`}>
        <div style={{ marginBottom: "7px" }}>
          {showlabel && (
            <label
              className="MBCorpoAScreen1Cond-Regular-Web"
              style={{ color: "#FFFFFF" }}
            >
              {label}
            </label>
          )}
        </div>
        {language == "it" ? (
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={it}>
            <MuiDatePicker
              inputRef={ref}
              label={label}
              inputFormat={inputFormat}
              className={"bg-[#FFFFFF]"}
              value={dateValue}
              onChange={(newValue: Date | null) => {
                onChange(newValue ? newValue.toString() : null);
              }}
              onAccept={(newValue: Date | null) => {
                onChange(newValue ? newValue.toString() : null);
              }}
              InputProps={{
                readOnly: true,
                sx: {
                  height: containerheight,
                  fontFamily: effectiveFontFamily,
                  color: "black",
                  "&::placeholder": {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  },
                  "&.MuiInputLabel-shrink": {
                    display: "none",
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  placeholder={"select a date"}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      height: containerheight,
                      fontFamily: effectiveFontFamily,
                      color: "black",
                      "&::placeholder": {
                        fontFamily: effectiveFontFamily,
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      "&.MuiInputLabel-root": {
                        fontFamily: effectiveFontFamily,
                        marginTop: "-8px",
                      },
                      "&::placeholder": {
                        fontFamily: effectiveFontFamily,
                      },
                      "&.MuiInputLabel-shrink": {
                        display: "none",
                      },
                    },
                  }}
                  style={{
                    width: containerwidth,
                    fontFamily: effectiveFontFamily,
                    height: containerheight,
                    borderRadius: "8px",
                    backgroundColor: InputColor ? "#D9D9D9" : "#FFFFFF",
                  }}
                  required={required}
                  helperText={""}
                />
              )}
              openTo={maxDate || minDate ? "year" : "day"}
              minDate={minDate}
              maxDate={maxDate}
              disableHighlightToday={!showTodayButton}
              disabled={readOnly}
            />
          </LocalizationProvider>
        ) : (
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={enUS}>
            <MuiDatePicker
              inputRef={ref}
              label={label}
              className={"bg-[#FFFFFF]"}
              inputFormat={inputFormat}
              value={dateValue}
              onChange={(newValue: Date | null) => {
                onChange(newValue ? newValue.toString() : null);
              }}
              onAccept={(newValue: Date | null) => {
                onChange(newValue ? newValue.toString() : null);
              }}
              InputProps={{
                readOnly: true,
                sx: {
                  height: containerheight,
                  fontFamily:
                    fontFamilyForLabel && fontFamilyForLabel != ""
                      ? fontFamilyForLabel
                      : "MBCorpoSTitle-Regular-Web-STitle-Regular",
                  color: "black",
                  "&::placeholder": {
                    fontFamily:
                      fontFamilyForLabel && fontFamilyForLabel != ""
                        ? fontFamilyForLabel
                        : "MBCorpoAScreen1Cond-Regular-Web",
                  },
                },
              }}
              renderInput={(params) =>
                renderCustomDateInput({
                  params,
                  containerwidth,
                  containerheight,
                  InputColor,
                  required,
                  commonStyles,
                })
              }
              openTo={maxDate || minDate ? "year" : "day"}
              minDate={minDate}
              maxDate={maxDate}
              disableHighlightToday={!showTodayButton}
              disabled={readOnly}
            />
          </LocalizationProvider>
        )}
      </div>
    </>
  );
});

export const DateRangePicker = forwardRef(DateRangePickerComponent);
export function DateRangePickerComponent(
  {
    required = false,
    className = "",
    label = "",
    disableOnDay = [],
    onChange = () => {},
    minDate = new Date(),
    color = "",
    InputColor = false,
    fontFamilyForLabel = "",
    fontFamilyForInput = "",
    ...props
  }: DateRangePickerProps,
  ref: ForwardedRef<HTMLInputElement | null>
) {
  // passing color dynamically to calendar.css file
  document.documentElement.style.setProperty("--selected-color", color);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    onChange(dates);
  };
  return (
    <div className={`w-full ${className} `}>
      <div style={{ marginBottom: "7px" }}>
        <label
          className={
            fontFamilyForLabel != ""
              ? fontFamilyForLabel
              : "MBCorpoAScreen1Cond-Regular-Web"
          }
          style={{ color: "#FFFFFF" }}
        >
          {label}
        </label>
      </div>
      <RangePicker
        locale={i18n.language}
        className={"w-full h-full bg-[#FFFFFF]"}
        dateFormat="dd MMM,yyyy"
        isClearable
        required={required}
        monthsShown={2}
        minDate={minDate}
        maxDate={props.maxDate}
        selected={startDate}
        selectsRange
        startDate={startDate}
        endDate={endDate}
        withPortal
        autoComplete="off"
        customInput={
          <TextField
            autoComplete={Date.now().toString()}
            label={label}
            required={required}
            fullWidth
            style={{
              borderRadius: "8px",
              backgroundColor: InputColor ? "#D9D9D9" : "#FFFFFF",
            }}
            inputRef={ref}
            InputProps={{
              readOnly: true,
              sx: {
                height: "63px",
                fontFamily: "MBCorpoSTitle-Regular-Web-STitle-Regular",
                "&::placeholder": {
                  fontFamily: "MBCorpoSTitle-Regular-Web-new",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                "&.MuiInputLabel-root": {
                  fontFamily:
                    fontFamilyForInput != ""
                      ? fontFamilyForInput
                      : "MBCorpoSTitle-Regular-Web-new",
                  marginTop: "5px",
                },
                "&::placeholder": {
                  fontFamily: "MBCorpoSTitle-Regular-Web-new",
                },
                "&.MuiInputLabel-shrink": {
                  marginTop: "13px",
                  color: "#00ADEF",
                  fontFamily: "MBCorpoSTitle-Regular-Web-new",
                  display: "none",
                },
              },
            }}
          />
        }
        filterDate={(e) => {
          const isEnabled = disableOnDay.indexOf(getDay(e)) > -1;
          return !isEnabled;
        }}
        onChange={handleDateChange}
      />
    </div>
  );
}

export function AppDateAndTimePicker({
  label,
  value,
  showTodayButton,
  minDateTime,
  onAccept,
  className = "",
  disableOnDay = [],
  required = false,
  readOnly = false,
}: DateAndTimePickerProps) {
  return (
    <div className={`${className}`}>
      <DateTimePicker
        disabled={readOnly}
        label={label}
        value={value || ""}
        onChange={() => {
          // console.log(e);
        }}
        renderInput={(params) => <TextField {...params} required={required} />}
        disableHighlightToday={!showTodayButton}
        minDateTime={minDateTime}
        onAccept={onAccept}
        shouldDisableDate={(date: Date) => {
          return disableOnDay.includes(date.getDay());
        }}
        ampm={true}
      />
    </div>
  );
}

export const AppDatePickerSeparate = forwardRef(
  function AppDatePickerSeparateComponent(
    {
      onChange = () => {},
      label,
      disableOnDay = [],
      onError = () => {},
      dayLabel = "Giorno",
      monthLabel = "Mese",
      yearLabel = "Anno",
      className = "",
      value,
      readOnly = false,
    }: DatePickerSeparateProps,
    ref: ForwardedRef<HTMLInputElement>
  ) {
    interface DatePickerFormat {
      label: string;
      views: CalendarPickerView[];
      inputFormat?: string;
      mask?: string;
      onChange?: () => void;
      disabled?: boolean;
    }

    const DatePickerStyle = useDatePickerStyles();
    const datePickers: Array<DatePickerFormat> = [];
    datePickers.push({
      label: dayLabel,
      views: ["day"],
      inputFormat: "dd",
      disabled: readOnly,
    });
    datePickers.push({
      label: monthLabel,
      views: ["month"],
      inputFormat: "MMM",
      disabled: readOnly,
    });
    datePickers.push({
      label: yearLabel,
      views: ["year"],
      inputFormat: "yyyy",
      disabled: readOnly,
    });
    return (
      <div className={`w-full h-full border-box flex flex-col  ${className}`}>
        <div className="h-8">
          <InputLabel>{label}</InputLabel>
        </div>

        <div
          className={`py-2 box-border items-center justify-center h-full flex flex-row gap-2 w-full ${DatePickerStyle.dateSeparated}`}
        >
          {datePickers.map((el: DatePickerFormat, index: number) => {
            return (
              <div className={"shrink h-full"} key={index}>
                <AppDatePicker
                  locale="it"
                  {...el}
                  value={value || ""} // Use null instead of empty string
                  inputRef={ref}
                  components={{
                    OpenPickerIcon: KeyboardArrowDown,
                  }}
                  onChange={(date: Date | null) => {
                    onChange(date?.toString() || null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      inputProps={{ readOnly: true }} // Prevent keyboard from opening
                      disabled={false}
                    />
                  )}
                  onAccept={(date: Date | null) => {
                    onChange(date?.toString() || null);
                  }}
                  onError={onError}
                  inputFormat="dd/MM/yyyy"
                  shouldDisableDate={(date: Date) => {
                    return disableOnDay.includes(date.getDay());
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
);
